exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sortable{cursor:pointer;position:relative;padding-right:20px}.sortable .arrow{position:absolute;right:5px;top:50%;transform:translateY(-50%);width:0;height:0;border-left:5px solid transparent;border-right:5px solid transparent;opacity:.6}.sortable .arrow.asc{border-bottom:5px solid #fff}.sortable .arrow.desc{border-top:5px solid #fff}.sortable.active .arrow{opacity:1}.nav.nav-tabs.type-nav-general{display:none}", ""]);

// exports
